<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="10"
      :search="search"
      :loading="isLoading"
      sort-by="calories"
      class="elevation-1 mb-10"
      style="cursor: pointer"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>

          <div class="text-center mr-5">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <a
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  style="text-decoration: underline"
                  >{{ $t("table.export") }}</a
                >
              </template>
              <v-list>
                <JsonExcel
                  :data="items"
                  :fields="exportFields"
                  type="csv"
                  :name="title + '.csv'"
                >
                  <v-list-item @click="onExportCsv()">
                    <!-- Need to include click action to have hover animation -->
                    <v-list-item-title>CSV</v-list-item-title>
                  </v-list-item>
                </JsonExcel>

                <v-list-item @click="onExportPdf()">
                  <!-- Need to include click action to have hover animation -->
                  <v-list-item-title>PDF</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                tile
                dark
                class="mb-2 primary-color"
                v-bind="attrs"
                v-on="on"
                @click="addItem()"
              >
                {{ $t("table.add") }} user
                <v-icon size="20" class="ml-1">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }} {{ $t(title) }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col md="12">
                      <v-form ref="editForm">
                        <v-text-field
                          v-model="editedItem.firstName"
                          label="First Name"
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.middleName"
                          label="Middle Name (Optional)"
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.lastName"
                          label="Last Name"
                        ></v-text-field>
                        <v-text-field
                          v-if="$store.state.role == 'ao' && editedIndex != -1"
                          v-model="newPassword"
                          label="New Password"
                        ></v-text-field>
                        <v-text-field
                          v-model="editedItem.email"
                          label="Email"
                          :disabled="editedIndex != -1"
                        ></v-text-field>
                        <v-checkbox
                          v-if="$store.state.role == 'ao' && editedIndex == -1"
                          v-model="onBehalfCentre"
                          label="Add on behalf of centre"
                        ></v-checkbox>
                        <v-select
                          :disabled="!onBehalfCentre"
                          v-if="$store.state.role == 'ao' && editedIndex == -1"
                          v-model="centre"
                          :items="centreNames"
                          label="Centre"
                          class="my-3"
                        ></v-select>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn tile color="blue darken-1" text @click="dialog = false"
                  >Cancel</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="
                    dialog = false;
                    onConfirmAction();
                  "
                  >Confirm</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template
        v-slot:item.actions="{ item }"
        v-if="$store.state.role != 'centre'"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <span>{{ $t("table.edit") }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="deleteItem(item)"
              >mdi-delete</v-icon
            >
          </template>
          <span>{{ $t("table.delete") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {
    JsonExcel,
  },
  props: {
    headers: Array,
    items: Array,
    title: String,
    btnText: String,
    routeTo: String,
    apiRoute: String,
    modalText: String,
    isLoading: Boolean,
  },
  mounted: function () {
    this.getCentres();
  },
  data: () => ({
    firstName: null,
    middleName: null,
    lastName: null,
    email: null,
    newPassword: null,
    centres: [],
    centreNames: [],
    centre: null,
    onBehalfCentre: false,
    show: false,
    search: "",
    dialog: false,
    deleteDialog: false,
    editedIndex: -1,
    editedItem: {},
    onConfirmAction: null,
    pdfData: null,
    pdfHeader: [
      { text: "Username", style: "tableHeader" },
      { text: "Email", style: "tableHeader" },
      { text: "Role", style: "tableHeader" },
    ],
    exportFields: {
      FirstName: "firstName",
      MiddleName: "middleName",
      LastName: "lastName",
      Email: "email",
      Role: "role",
      "Updated At": "updatedAt",
    },
  }),
  watch: {
    onBehalfCentre: function (newValue) {
      this.onBehalfCentre = newValue;
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? `Add` : `Edit`;
    },
  },
  methods: {
    addItem() {
      this.editedIndex = -1;
      this.editedItem = {};
      this.onConfirmAction = this.onAddOptions;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);

      const names = item.username.split(" ").filter((name) => name != "");

      if (names.length == 2) {
        item.firstName = names[0];
        item.lastName = names[1];
      } else if (names.length == 3) {
        item.firstName = names[0];
        item.middleName = names[1];
        item.lastName = names[2];
      }

      this.editedItem = Object.assign({}, item);
      this.onConfirmAction = this.onEditOption;
      this.dialog = true;
    },
    deleteItem(item) {
      const confirmDelete = window.confirm(
        `Are you sure to delete ${item.firstName} ${item.middleName} ${item.lastName}?`
      );
      if (confirmDelete) {
        this.onDeleteOption(item._id);
      }
    },
    onAddOptions: function () {
      const data = {
        firstName: this.editedItem.firstName,
        middleName: this.editedItem.middleName,
        lastName: this.editedItem.lastName,
        centre: this.centre,
        email: this.editedItem.email,
      };

      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onEditOption: function () {
      let data;

      if (this.newPassword) {
        data = {
          firstName: this.editedItem.firstName,
          middleName: this.editedItem.middleName,
          lastName: this.editedItem.lastName,
          newPassword: this.newPassword,
          email: this.editedItem.email,
        };
      } else {
        data = {
          firstName: this.editedItem.firstName,
          middleName: this.editedItem.middleName,
          lastName: this.editedItem.lastName,
          email: this.editedItem.email,
        };
      }

      fetch(
        `${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/${this.editedItem._id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onDeleteOption: function (id) {
      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onExportCsv: function () {},
    onExportPdf: function () {
      this.pdfData = this.items.map((item) => [
        item.firstName,
        item.middleName,
        item.lastName,
        item.email,
        item.role,
      ]);

      this.pdfData.unshift(this.pdfHeader);

      var doc = {
        content: [
          { text: `${this.title} List`, style: "header" },
          {
            style: "tableExample",
            table: {
              widths: ["*", "*", "*"],
              headerRows: 1,
              body: this.pdfData,
            },
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
      };
      pdfMake.createPdf(doc).open();
    },
    getCentres: async function () {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/centres`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
          }
        );

        const data = await response.json();

        this.centres = data.centres;
        this.centreNames = data.centres.map((centre) => centre.name);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>